import React, { useRef, useEffect, useState } from 'react';
import { useMap } from "react-leaflet";
import { useDispatch, useSelector } from 'react-redux';
import { setNewMapState } from '../../mapSlice';
// import L from 'leaflet';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Paper from '@material-ui/core/Paper';
import PauseIcon from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
// import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
// import SkipNextIcon from '@material-ui/icons/SkipNext';
import Slider from '@material-ui/core/Slider';
import TimeDisplay from '../TimeDisplay/TimeDisplay';
import { makeStyles } from '@material-ui/core/styles';
import './ControlsContainer.css';
import dayjs from 'dayjs';

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& > *': {
      alignItems: 'center',
      display: 'flex',
      fontSize: '1.1rem',
      // justifyContent: 'space-between',
      // margin: theme.spacing(1),
      width: '100%'
    },
  },
  paper: {
    background: 'black',
    borderRadius: '0px',
    color: 'white'
  },
  slider: {
    marginRight: '1vw',
    width: '40%',
  },
  buttonGroup: {
    marginRight: '1vw',
  }
}));

const ControlsContainer = () => {
  const map = useMap();
  const dispatch = useDispatch();
  const frame = useSelector(state => state.map.frame);
  const spanHours = useSelector(state => state.map.spanHours);
  const isPlaying = useSelector(state => state.map.isPlaying);
  // const layersArr = useSelector(state => state.map.layersArr);

  const controlsRef = useRef('');
  const classes = useStyles();
  // eslint-disable-next-line no-unused-vars
  const [localFrame, setLocalFrame] = useState(frame);

  useEffect(() => {
    // L.DomEvent.disableClickPropagation(controlsRef.current);
  }, []);

  const handlePlay = () => {
    dispatch(setNewMapState({ isPlaying: !isPlaying }));
  }

  // const handleIncrement = () => {
  //   dispatch(increment());
  // }

  // const handleDecrement = () => {
  //   dispatch(decrement());
  // }

  const handleSlider = (event, newValue) => {
    if (map.dragging._draggable) {
      map.dragging._draggable._enabled = false;
    }
    setLocalFrame(newValue);
    dispatch(setNewMapState({ frame: newValue }))
  }

  const handleCommitChange = (e) => {
    if (map.dragging._draggable) {
      map.dragging._draggable._enabled = true;
    }
  }

  // const marks = [
  //   {
  //     value: 0,
  //     label: dayjs().subtract(1, 'h').format('ha')
  //   },
  //   {
  //     value: spanHours - 1,
  //     label: dayjs().add(spanHours - 1, 'h').format('ha')
  //   }
  // ];

  return (
    <div className={"leaflet-bottom leaflet-left "} ref={controlsRef} style={{ bottom: '26px', width: '500px' }}>
      <div className={"leaflet-control leaflet-bar"} style={{ width: '100%' }}>
        <Paper className={classes.paper}>
          <div className={classes.root}>
            <div>
              <ButtonGroup color="primary" aria-label="outlined primary button group" className={classes.buttonGroup}>
                {/* <Button onClick={handleDecrement}><SkipPreviousIcon /></Button> */}
                <Button onClick={handlePlay}>{isPlaying ? <PauseIcon /> : <PlayArrowIcon />}</Button>
                {/* <Button onClick={handleIncrement}><SkipNextIcon /></Button> */}
              </ButtonGroup>
              {/* <input type="range" name="fxHours" value={frame} id="fxHours" min={'0'} max={spanHours - 1} onChange={handleSlider} /> */}
              <Slider
                aria-label={'Timeline'}
                className={classes.slider}
                // defaultValue={frame}
                value={frame}
                id={'fxHours'}
                valueLabelDisplay="auto"
                valueLabelFormat={dayjs().add(frame - 1, 'h').format('ha')}
                step={1}
                marks
                min={0}
                max={spanHours - 1}
                onChange={handleSlider}
                onChangeCommitted={handleCommitChange}
              />
              <TimeDisplay />
            </div>
          </div>
        </Paper>
      </div>
    </div>
  )
}

export default ControlsContainer
